import {useListView} from '../core/ListViewProvider'
import {ReservationsListToolbar} from './ReservationListToolbar'
import {ReservationsListGrouping} from './ReservationListGrouping'
import {ReservationsListSearchComponent} from './ReservationListSearchComponent'

const ReservationsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6 pb-4 flex-wrap gap-3'>
      <ReservationsListSearchComponent />
      <div className='card-toolbar ms-auto'>
        {selected.length > 0 ? <ReservationsListGrouping /> : <ReservationsListToolbar />}
      </div>
    </div>
  )
}

export {ReservationsListHeader}
